export default "__VITE_ASSET__sGs8YKxG__"